









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BOverlay, BFormDatepicker } from "bootstrap-vue";
import { VueEditor } from "vue2-editor";
import {
  uploadFile,
  getFileViewUrl,
  getFileDownloadUrl,
} from "@/services/storage";
import { formatPhone, fileSize, fileIcon, randomId } from "@/utils";
import SelectPopover from "@/components/SelectPopover.vue";
import InputPopover from "@/components/InputPopover.vue";
import DatePopover from "@/components/DatePopover.vue";
import PatientSearchPopover from "@/components/PatientSearchPopover.vue";
import TaskPopover from "./TaskPopover.vue";
import LogViewer from "./LogViewer.vue";
import PatientEditor from "@/components/patient/PatientEditor.vue";
import {
  CaseLogEntry,
  CaseRecord,
  Form,
  FormQuestion,
  Tab,
  User,
} from "@/store/modules/types";
import { CaseLogType, CaseField } from "@/store/modules/enums";

@Component({
  components: {
    BOverlay,
    BFormDatepicker,
    VueEditor,
    SelectPopover,
    InputPopover,
    DatePopover,
    PatientSearchPopover,
    TaskPopover,
    LogViewer,
    PatientEditor,
  },
  computed: {
    ...mapState("auth", ["user", "entityId"]),
    ...mapState("gaps", ["campaigns"]),
    ...mapState("cases", [
      "types",
      "triggers",
      "refSources",
      "riskLevels",
      "activity",
      "status",
      "closeReasons",
      "forms",
      "clinicalIndicators",
      "users",
      "carePlan",
    ]),
  },
  filters: {
    phone: formatPhone,
  },
})
export default class CaseEditor extends Vue {
  @Prop(String) readonly tabId!: string;
  @Prop() readonly caseRecord!: CaseRecord;
  user!: User;
  entityId!: string;
  showPatientSearch = false;
  showTaskPopover = false;
  carePlanTypeId = "";
  carePlanTypeProblems: any[] = [];
  //
  types!: any[];
  triggers!: any[];
  refSources!: any[];
  riskLevels!: any[];
  activity!: any[];
  status!: any[];
  closeReasons!: any[];
  users!: any[];
  //
  loading = {
    patient: false,
    forms: false,
    files: false,
    carePlan: false,
    medication: false,
    comments: false,
  };
  record: CaseRecord = {
    // MAIN INFO
    entityId: "",
    campaignId: "",
    id: "",
    typeId: "",
    triggerId: "",
    referralSourceId: "",
    referralDate: "",
    patientId: "",
    patientInfo: {
      demographic: null,
      contacts: [],
      providers: [],
      gaps: [],
    },
    riskLevelId: "",
    activityId: "",
    medication: "",
    medicationNotes: [],
    lang: "",
    statusId: "PEN",
    closeReasonId: "",
    ownerUserId: "",
    problems: [],
    interventions: [],
    goals: [],
    tasks: [],
    forms: [],
    files: [],
    clinicalIndicators: [],
    comments: [],
    created: null,
    creatorUsername: null,
    updated: null,
    modifierUsername: null,
  };
  selectedForm = {
    form: {} as Form,
    questions: [] as FormQuestion[],
  };
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  saved = false;
  lastSave = "";
  @Watch("record", { deep: true })
  onRecordChanged() {
    const { tabId } = this;
    const record = JSON.parse(JSON.stringify(this.record));
    this.$store.commit("cases/SET_TAB_CASE_RECORD", { tabId, record });
    this.saved = false;
  }
  async setPatient(id: string) {
    this.loading.patient = true;
    try {
      // GET PATIENT INFO
      const info = {
        demographic: await this.$store.dispatch("patients/getPatient", id),
        contacts: await this.$store.dispatch("patients/getContacts", id),
        providers: await this.$store.dispatch("patients/getProviders", id),
        gaps: await this.$store.dispatch("patients/getGaps", id),
      };
      // SET CASE PATIENT
      this.record.patientId = id;
      this.record.patientInfo = info;
      this.record.lang = info.demographic.lang;
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.patient = false;
    }
  }
  async getCarePlanTypeProblems(planTypeId: string) {
    try {
      if (planTypeId) {
        this.carePlanTypeId = planTypeId;
        this.carePlanTypeProblems = await this.$store.dispatch(
          "cases/getCarePlanTypeProblems",
          planTypeId
        );
      } else {
        this.carePlanTypeProblems = [];
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getCarePlan(problemList: Array<number>) {
    if (problemList.length) {
      this.loading.carePlan = true;
      try {
        // GET CARE PLAN ASYNC
        const data = await this.$store.dispatch("cases/getCarePlan", {
          planTypeId: this.carePlanTypeId,
          problemList,
        });
        // ADD PROBLEMS
        const problems: any[] = data.problems.map((item) => {
          item.statusId = "OPN";
          return item;
        });
        problems.forEach((item) => {
          const exists = this.record.problems.find((i) => i.id === item.id);
          if (!exists) this.record.problems.push(item);
        });
        // ADD INTERVENTIONS
        const interventions: any[] = data.interventions.map((item) => {
          item.statusId = "PEN";
          return item;
        });
        interventions.forEach((item) => {
          const exists = this.record.interventions.find(
            (i) => i.id === item.id
          );
          if (!exists) this.record.interventions.push(item);
        });
        // ADD GOALS
        const goals: any[] = data.goals.map((item) => {
          item.statusId = "PEN";
          return item;
        });
        goals.forEach((item) => {
          const exists = this.record.goals.find((i) => i.id === item.id);
          if (!exists) this.record.goals.push(item);
        });
        // ADD TASKS
        const tasks: any[] = data.tasks.map((item) => {
          item.key = randomId(8);
          item.statusId = "OPN";
          item.priorityId = "NM";
          item.dueDate = new Date();
          item.ownerUserId = this.user.id.toString();
          return item;
        });
        tasks.forEach((item) => {
          const exists = this.record.tasks.find(
            (i) => i.carePlanTaskId === item.carePlanTaskId
          );
          if (!exists) this.record.tasks.push(item);
        });
        //
      } catch (error) {
        console.log(error);
      } finally {
        this.loading.carePlan = false;
      }
    }
  }
  async save(close: boolean) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      // CHECK BASIC INFO
      if (!this.record.patientId) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "<b>Patient</b> is required.",
        });
      }
      // SAVE CASE ASYNC
      const caseId = await this.$store.dispatch("cases/save", this.record);
      this.$bvToast.toast(
        `Case #${caseId} has been ${this.record.id ? "saved" : "created"}.`,
        {
          title: "WaitingMed",
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
          solid: true,
        }
      );
      if (!this.record.id) {
        this.record.id = caseId;
        this.record.created = this.$moment().format();
        this.record.creatorUsername = this.user.userName;
      } else {
        this.record.updated = this.$moment().format();
        this.record.modifierUsername = this.user.userName;
      }
      this.$nextTick(() => {
        this.lastSave = this.$moment().format();
        this.saved = true;
        if (close) this.close();
        else {
          this.$store.commit("cases/SET_TAB_NAME", {
            id: this.tabId,
            name: `Case ${caseId}`,
          });
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  close() {
    if (this.saved) {
      this.$store.commit("cases/REMOVE_TAB", this.tabId);
    } else {
      this.$modal.show("dialog", {
        title: "Close Tab",
        text: "There are unsaved changes. Are you sure?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.$store.commit("cases/REMOVE_TAB", this.tabId);
              this.$modal.hide("dialog");
            },
          },
          {
            title: "No",
            default: true,
          },
        ],
      });
    }
  }
  async getMedicationNotes() {
    try {
      this.record.medicationNotes = await this.$store.dispatch("cases/getLog", {
        caseId: this.record.id,
        typeId: CaseLogType.MEDICATION_NOTE,
      });
    } catch (error) {
      console.log(error);
    }
  }
  async getComments() {
    try {
      this.record.comments = await this.$store.dispatch("cases/getLog", {
        caseId: this.record.id,
        typeId: CaseLogType.CASE_MANAGER_COMMENT,
      });
    } catch (error) {
      console.log(error);
    }
  }
  async saveMedicationNote(note: string) {
    if (!note) return;
    this.loading.medication = true;
    try {
      // SAVE NOTE ASYNC
      const entry: CaseLogEntry = {
        caseId: this.record.id,
        typeId: CaseLogType.MEDICATION_NOTE,
        comment: note,
      };
      await this.$store.dispatch("cases/saveLog", entry);
      this.getMedicationNotes();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.medication = false;
    }
  }
  async saveComment(comment: string) {
    if (!comment) return;
    this.loading.comments = true;
    try {
      // SAVE COMMENT ASYNC
      const entry: CaseLogEntry = {
        caseId: this.record.id,
        typeId: CaseLogType.CASE_MANAGER_COMMENT,
        comment,
      };
      await this.$store.dispatch("cases/saveLog", entry);
      this.getComments();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.comments = false;
    }
  }
  async updateComment(item) {
    if (!item.comment) return;
    try {
      const { id, taskId, typeId, comment } = item;
      const entry: CaseLogEntry = {
        id,
        caseId: this.record.id,
        taskId,
        typeId,
        comment,
      };
      // UPDATE COMMENT ASYNC
      await this.$store.dispatch("cases/saveLog", entry);
      //
    } catch (error) {
      console.log(error);
    }
  }
  delCarePlanProblem(item) {
    if (this.record.id && item.hasOwnProperty("removed")) {
      item.removed = !item.removed;
    } else {
      const { problems } = this.record;
      const index = problems.findIndex((t) => t.id === item.id);
      problems.splice(index, 1);
    }
  }
  addCarePlanIntervention(item) {
    const { interventions } = this.record;
    const exists = interventions.find((i) => i.id === item.id);
    if (exists) return;
    else interventions.push(item);
  }
  delCarePlanIntervention(item) {
    if (this.record.id && item.hasOwnProperty("removed")) {
      item.removed = !item.removed;
    } else {
      const { interventions } = this.record;
      const index = interventions.findIndex((t) => t.id === item.id);
      interventions.splice(index, 1);
    }
  }
  addCarePlanGoal(item) {
    const { goals } = this.record;
    const exists = goals.find((i) => i.id === item.id);
    if (exists) return;
    else goals.push(item);
  }
  delCarePlanGoal(item) {
    if (this.record.id && item.hasOwnProperty("removed")) {
      item.removed = !item.removed;
    } else {
      const { goals } = this.record;
      const index = goals.findIndex((t) => t.id === item.id);
      goals.splice(index, 1);
    }
  }
  addCarePlanTask(item) {
    const { tasks } = this.record;
    const exists = tasks.find((i) => i.carePlanTaskId === item.carePlanTaskId);
    if (exists) return;
    else {
      const task = JSON.parse(JSON.stringify(item));
      task.key = randomId(8);
      task.ownerUserId = this.user.id.toString();
      task.dueDate = new Date();
      task.archived = false;
      tasks.push(task);
    }
  }
  addCustomTask(item) {
    const task = JSON.parse(JSON.stringify(item));
    task.key = randomId(8);
    task.ownerUserId = this.user.id.toString();
    task.archived = false;
    this.record.tasks.push(task);
  }
  delTask(item) {
    if (this.record.id && item.hasOwnProperty("archived")) {
      item.archived = !item.archived;
    } else {
      const { tasks } = this.record;
      const index = tasks.findIndex((t) => t.key === item.key);
      tasks.splice(index, 1);
    }
  }
  addForm(item) {
    const { forms } = this.record;
    const exists = forms.find((i) => i.id === item.id);
    if (exists) return;
    else forms.push(item);
  }
  delForm(item) {
    if (this.record.id && item.hasOwnProperty("removed")) {
      item.removed = !item.removed;
    } else {
      const { forms } = this.record;
      const index = forms.findIndex((t) => t.id === item.id);
      forms.splice(index, 1);
    }
  }
  async openForm(form: Form, wizard: boolean) {
    // CHECK CASE ID
    if (!this.record.id) {
      this.$modal.show("dialog", {
        title: "WaitingMed",
        text: "Please save this <b>case</b> first.",
      });
      return;
    }
    // LOAD QUESTIONS
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { demographic } = this.record.patientInfo;
      const questions: FormQuestion[] = await this.$store.dispatch(
        "cases/getFormQuestions",
        {
          caseId: this.record.id,
          formId: form.id,
        }
      );
      questions.forEach((q) => {
        if (q.options && q.options.caseField) {
          const { caseField } = q.options;
          let { answer } = q;
          switch (caseField) {
            // CASE
            case CaseField.CASE_ID:
              answer.value = this.record.id;
              break;
            case CaseField.CASE_TYPE: {
              const item = this.types.find(
                (item) => item.id === this.record.typeId
              );
              answer.value = item ? item.name : "CASE TYPE NOT FOUND";
              break;
            }
            case CaseField.CASE_TRIGGER: {
              const item = this.triggers.find(
                (item) => item.id === this.record.triggerId
              );
              answer.value = item ? item.name : "CASE TRIGGER NOT FOUND";
              break;
            }
            case CaseField.CASE_REF_SOURCE: {
              const item = this.refSources.find(
                (item) => item.id === this.record.referralSourceId
              );
              answer.value = item ? item.name : "CASE REF SOURCE NOT FOUND";
              break;
            }
            case CaseField.CASE_REF_DATE:
              answer.value = this.record.referralDate;
              break;
            case CaseField.CASE_RISK_LEVEL: {
              const item = this.riskLevels.find(
                (item) => item.id === this.record.riskLevelId
              );
              answer.value = item ? item.name : "CASE RISK LEVEL NOT FOUND";
              break;
            }
            case CaseField.CASE_ACTIVITY: {
              const item = this.activity.find(
                (item) => item.id === this.record.activityId
              );
              answer.value = item ? item.name : "CASE ACTIVITY NOT FOUND";
              break;
            }
            case CaseField.CASE_MEDICATION:
              answer.value = this.record.medication;
              break;
            case CaseField.CASE_STATUS: {
              const item = this.status.find(
                (item) => item.id === this.record.statusId
              );
              answer.value = item ? item.name : "CASE STATUS NOT FOUND";
              break;
            }
            case CaseField.CASE_CLOSE_REASON: {
              const item = this.closeReasons.find(
                (item) => item.id === this.record.closeReasonId
              );
              answer.value = item ? item.name : "CASE CLOSE REASON NOT FOUND";
              break;
            }
            case CaseField.CASE_OWNER: {
              const item = this.users.find(
                (item) => item.id === this.record.ownerUserId
              );
              answer.value = item ? item.longName : "CASE OWNER NOT FOUND";
              break;
            }
            // PATIENT
            case CaseField.PATIENT_ID:
              answer.value = this.record.patientId;
              break;
            case CaseField.PATIENT_FIRST_NAME:
              answer.value = demographic.firstName;
              break;
            case CaseField.PATIENT_LAST_NAME:
              answer.value = demographic.lastName;
              break;
            case CaseField.PATIENT_LAST_NAME_2:
              answer.value = demographic.lastName2;
              break;
            case CaseField.PATIENT_FULL_NAME:
              answer.value =
                demographic.lastName + ", " + demographic.firstName;
              break;
            case CaseField.PATIENT_BIRTHDATE:
              answer.value = demographic.birthdate;
              break;
            case CaseField.PATIENT_GENDER:
              answer.value = demographic.genderName;
              break;
            case CaseField.PATIENT_ADDRESS_LINE_1:
              answer.value = demographic.addressLine1;
              break;
            case CaseField.PATIENT_ADDRESS_LINE_2:
              answer.value = demographic.addressLine2;
              break;
            case CaseField.PATIENT_CITY:
              answer.value = demographic.city;
              break;
            case CaseField.PATIENT_STATE:
              answer.value = demographic.state;
              break;
            case CaseField.PATIENT_ZIP:
              answer.value = demographic.zip;
              break;
            case CaseField.PATIENT_COUNTRY:
              answer.value = demographic.countryName;
              break;
            case CaseField.PATIENT_FULL_ADDRESS:
              answer.value = demographic.address;
              break;
            case CaseField.PATIENT_INSURER:
              answer.value = demographic.insurerName;
              break;
            case CaseField.PATIENT_MEMBER_ID:
              answer.value = demographic.insurerMemberId;
              break;
            case CaseField.PATIENT_PCP_NAME:
              answer.value = demographic.pcpProviderName;
              break;
            case CaseField.PATIENT_CONTACT_NAME:
              answer.value = demographic.contactName;
              break;
            case CaseField.PATIENT_HOME_PHONE:
              answer.value = demographic.homePhone;
              break;
            case CaseField.PATIENT_MOBILE_PHONE:
              answer.value = demographic.mobilePhone;
              break;
            case CaseField.PATIENT_OTHER_PHONE:
              answer.value = demographic.otherPhone;
              break;
            case CaseField.PATIENT_OTHER_PHONE_2:
              answer.value = demographic.otherPhone2;
              break;
            case CaseField.PATIENT_EMAIL:
              answer.value = demographic.email;
              break;
            case CaseField.PATIENT_LANG:
              answer.value = demographic.lang;
              break;
            case CaseField.PATIENT_EMR_ID:
              answer.value = demographic.EMR_ID;
              break;
            //
          }
        }
      });
      // CREATE FORM TAB
      const id = randomId(6);
      const tab: Tab = {
        id,
        name: `Case ${this.record.id} - ${form.name}`,
        component: "CaseForm",
        props: {
          tabId: id,
          caseRecord: this.record,
          form: form,
          formQuestions: questions,
          formWizard: wizard,
        },
        showRemove: true,
      };
      // ADD FORM TAB
      this.$store.commit("cases/ADD_NEW_TAB", tab);
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveFormAnswers(answers) {
    this.loading.forms = true;
    try {
      await this.$store.dispatch("cases/saveFormAnswers", {
        caseId: this.record.id,
        formId: this.selectedForm.form.id,
        answers,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.forms = false;
    }
  }
  async uploadCaseFile() {
    if (this.fileInput.files) {
      this.loading.files = true;
      const { entityId } = this;
      try {
        for (let i = 0; i < this.fileInput.files.length; i++) {
          const file = this.fileInput.files[i];
          const id = await uploadFile(entityId, file);
          this.record.files.push({
            id,
            name: file.name,
            size: file.size,
            description: null,
            created: new Date(),
            createdBy: this.user.userName,
            updated: null,
            updatedBy: null,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading.files = false;
      }
    }
  }
  async fileView(item) {
    this.loading.files = true;
    try {
      const url = await getFileViewUrl(item.id);
      window.open(url, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.files = false;
    }
  }
  async fileDownload(item) {
    this.loading.files = true;
    try {
      const url = await getFileDownloadUrl(item.id);
      window.location.href = url;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading.files = false;
    }
  }
  async fileArchive(item) {
    const { files } = this.record;
    const index = files.findIndex((t) => t.id === item.id);
    if (this.record.id) {
      this.$modal.show("dialog", {
        title: "Remove " + item.name,
        text: "Are you sure?",
        buttons: [
          {
            title: "Yes",
            handler: async () => {
              this.loading.files = true;
              try {
                const caseId = this.record.id;
                const { id } = item;
                await this.$store.dispatch("cases/archiveFile", {
                  caseId,
                  id,
                });
                files.splice(index, 1);
                this.$modal.hide("dialog");
              } catch (error) {
                console.log(error);
              } finally {
                this.loading.files = false;
              }
            },
          },
          {
            title: "No",
            default: true,
          },
        ],
      });
    } else {
      files.splice(index, 1);
    }
  }
  async setFileDesc(item) {
    // console.log(item);
  }
  addClinicalIndicator(item) {
    const { clinicalIndicators } = this.record;
    const { id, name } = item;
    clinicalIndicators.push({
      key: randomId(8),
      id,
      name,
      value: null,
      level: null,
      date: null,
      archived: false,
    });
  }
  delClinicalIndicator(item) {
    if (this.record.id && item.hasOwnProperty("archived")) {
      item.archived = !item.archived;
    } else {
      const { clinicalIndicators } = this.record;
      const index = clinicalIndicators.findIndex((t) => t.id === item.id);
      clinicalIndicators.splice(index, 1);
    }
  }
  showLog() {
    this.$modal.show("log-viewer");
  }
  showPDF() {
    // CREATE PDF TAB
    const id = randomId(6);
    const tab: Tab = {
      id,
      name: `Case ${this.record.id} - PDF`,
      component: "CasePDF",
      props: {
        tabId: id,
        caseRecord: this.record,
      },
      showRemove: true,
    };
    // ADD PDF TAB
    this.$store.commit("cases/ADD_NEW_TAB", tab);
    //
  }
  get recordGoals() {
    return this.record.goals.filter((item) => !item.removed);
  }
  get fileInput() {
    return document.querySelector("input[type='file']") as HTMLInputElement;
  }
  get fileIcon() {
    return fileIcon;
  }
  get fileSize() {
    return fileSize;
  }
  get patient() {
    return this.record.patientInfo;
  }
  async mounted() {
    if (this.caseRecord) {
      this.record = JSON.parse(JSON.stringify(this.caseRecord));
      if (this.record.patientId && !this.record.patientInfo.demographic) {
        await this.setPatient(this.record.patientId);
      }
      if (this.record.id) {
        if (!this.record.medicationNotes.length) {
          await this.getMedicationNotes();
        }
        if (!this.record.comments.length) {
          await this.getComments();
        }
      }
      this.saved = true;
    } else {
      this.record.entityId = this.entityId;
      this.record.ownerUserId = this.user.id.toString();
    }
  }
}
